module.exports = __webpack_public_path__ + "img/banner-writer.56b404cb.png";